import React from "react"
import ClinicalHistoryPatientSummaryView from "../features/clinical-history/components/ClinicalHistoryPatientSummaryView"
import {
  DiagnosisInitialModal,
  EndoHistoryModal,
  PerioHistoryModal,
  SurgeryHistoryModal,
  OrthoHistoryModal,
  PediatricHistoryModal,
  QrPreIntakeReviewModal,
} from "../features/clinical-history/components/ClinicalHistoryModals"

export default function ClinicalHistoryPatientPage({
  patientDisplayName,
  dismissedQrReviewId,
  hub,
  age,
  form,
  isFormDirty,
  isReadOnly,
  readOnlyReason,
  saving,
  onOpenBaseEditor,
  onOpenSpecialtyCases,

  onBackToLauncher,
  onOpenPatientsProfile,
  onOpenOdontogram,

  qrLoading,
  qrGenerating,
  qrInfo,
  qrImageUrl,
  qrImageLoading,
  onGenerateQrLink,
  onCopyQrLink,
  onOpenQrLink,
  onDownloadQr,
  onPrintQrPoster,
  onOpenUpgrade,

  hubFormHistoryItems,
  hubTimelineItems,

  onHubHistoryAction,
  onHubHistorySecondaryAction,

  endoModal,
  perioModal,
  surgeryModal,
  orthoModal,
  pediatricModal,
  diagnosisModal,

  qrReviewModalOpen,
  setQrReviewModalOpen,
  markingQrReviewed,
  onUseQrDataAndMarkReviewed,
  onMarkQrReviewed,
}) {
  return (
    <div style={{ padding: 24, background: "#f8fafc", minHeight: "100vh" }}>
      <EndoHistoryModal
        open={endoModal.open}
        onClose={endoModal.closeModal}
        form={endoModal.form}
        setForm={endoModal.setForm}
        saving={endoModal.saving || endoModal.loading}
        onSave={endoModal.saveInstance}
        latestInstance={endoModal.latestInstance}
        isReadOnly={isReadOnly}
        readOnlyReason={readOnlyReason}
      />

      <PerioHistoryModal
        open={perioModal.open}
        onClose={perioModal.closeModal}
        form={perioModal.form}
        setForm={perioModal.setForm}
        saving={perioModal.saving || perioModal.loading}
        onSave={perioModal.saveInstance}
        latestInstance={perioModal.latestInstance}
        isReadOnly={isReadOnly}
        readOnlyReason={readOnlyReason}
      />

      <SurgeryHistoryModal
        open={surgeryModal.open}
        onClose={surgeryModal.closeModal}
        form={surgeryModal.form}
        setForm={surgeryModal.setForm}
        saving={surgeryModal.saving || surgeryModal.loading}
        onSave={surgeryModal.saveInstance}
        latestInstance={surgeryModal.latestInstance}
        isReadOnly={isReadOnly}
        readOnlyReason={readOnlyReason}
      />

      <OrthoHistoryModal
        open={orthoModal.open}
        onClose={orthoModal.closeModal}
        form={orthoModal.form}
        setForm={orthoModal.setForm}
        saving={orthoModal.saving || orthoModal.loading}
        onSave={orthoModal.saveInstance}
        latestInstance={orthoModal.latestInstance}
        isReadOnly={isReadOnly}
        readOnlyReason={readOnlyReason}
      />

      <PediatricHistoryModal
        open={pediatricModal.open}
        onClose={pediatricModal.closeModal}
        form={pediatricModal.form}
        setForm={pediatricModal.setForm}
        saving={pediatricModal.saving || pediatricModal.loading}
        onSave={pediatricModal.saveInstance}
        latestInstance={pediatricModal.latestInstance}
        isReadOnly={isReadOnly}
        readOnlyReason={readOnlyReason}
      />

      <DiagnosisInitialModal
        open={diagnosisModal.open}
        onClose={diagnosisModal.closeModal}
        form={diagnosisModal.form}
        setForm={diagnosisModal.setForm}
        saving={diagnosisModal.saving || diagnosisModal.loading}
        onSave={diagnosisModal.saveInstance}
        latestInstance={diagnosisModal.latestInstance}
        isReadOnly={isReadOnly}
        readOnlyReason={readOnlyReason}
      />

      <QrPreIntakeReviewModal
        open={qrReviewModalOpen}
        onClose={() => setQrReviewModalOpen(false)}
        qrIntake={hub?.qrIntake || null}
        onUseData={onUseQrDataAndMarkReviewed}
        onMarkReviewed={onMarkQrReviewed}
        markingReviewed={markingQrReviewed}
      />

      <ClinicalHistoryPatientSummaryView
        patientDisplayName={patientDisplayName}
        dismissedQrReviewId={dismissedQrReviewId}
        hub={hub}
        age={age}
        form={form}
        isFormDirty={isFormDirty}
        isReadOnly={isReadOnly}
        readOnlyReason={readOnlyReason}
        saving={saving}
        onBackToLauncher={onBackToLauncher}
        onOpenPatientsProfile={onOpenPatientsProfile}
        onOpenOdontogram={onOpenOdontogram}
        onOpenBaseEditor={onOpenBaseEditor}
        onOpenSpecialtyCases={onOpenSpecialtyCases}
        qrLoading={qrLoading}
        qrGenerating={qrGenerating}
        qrInfo={qrInfo}
        qrImageUrl={qrImageUrl}
        qrImageLoading={qrImageLoading}
        onGenerateQrLink={onGenerateQrLink}
        onCopyQrLink={onCopyQrLink}
        onOpenQrLink={onOpenQrLink}
        onDownloadQr={onDownloadQr}
        onPrintQrPoster={onPrintQrPoster}
        onOpenUpgrade={onOpenUpgrade}
        hubFormHistoryItems={hubFormHistoryItems}
        hubTimelineItems={hubTimelineItems}
        onHubHistoryAction={onHubHistoryAction}
        onHubHistorySecondaryAction={onHubHistorySecondaryAction}
      />
    </div>
  )
}